// Keeps the PPGF/Beam <sl-tooltip> PDP info popup open while focus is inside it,
// so links in the popup are reachable via keyboard. 

(() => {
  const SELECTOR = 'sl-tooltip.ppgf-disclosure-tooltip';
  const FLAG = '__tarteA11yAttached';

  function tooltipFor(target) {
    return target instanceof Element ? target.closest(SELECTOR) : null;
  }

  function stopIfMovingInside(e) {
    const tooltip = tooltipFor(e.target);
    if (!tooltip) return;
    const next = e.relatedTarget;
    if (next instanceof Element && tooltip.contains(next)) {
      e.stopImmediatePropagation();
    }
  }

  function reopenIfClosed(e) {
    const tooltip = tooltipFor(e.target);
    if (tooltip && !tooltip.open) tooltip.open = true;
  }

  function cancelHideIfFocusInside(e) {
    const tooltip = tooltipFor(e.target);
    if (!tooltip) return;
    const root = e.currentTarget;
    const active = (root && 'activeElement' in root && root.activeElement) || document.activeElement;
    if (active && active !== document.body && tooltip.contains(active)) {
      e.preventDefault();
    }
  }

  function attachToRoot(root) {
    if (!root || root[FLAG]) return;
    root[FLAG] = true;
    root.addEventListener('blur', stopIfMovingInside, true);
    root.addEventListener('focusout', stopIfMovingInside, true);
    root.addEventListener('focusin', reopenIfClosed, true);
    root.addEventListener('sl-hide', cancelHideIfFocusInside, true);
  }

  function walkRoots(root) {
    attachToRoot(root);
    const doc = root.ownerDocument || document;
    const walker = doc.createTreeWalker(root, NodeFilter.SHOW_ELEMENT);
    let node;
    while ((node = walker.nextNode())) {
      if (node.shadowRoot) walkRoots(node.shadowRoot);
    }
  }

  // Intercept future attachShadow calls so we catch shadow roots created after
  // this script loads (e.g. when Beam's custom element upgrades).
  const originalAttachShadow = Element.prototype.attachShadow;
  Element.prototype.attachShadow = function (init) {
    const root = originalAttachShadow.call(this, init);
    if (init && init.mode === 'open') attachToRoot(root);
    return root;
  };

  walkRoots(document);
})();
